import { useRecoilState } from 'recoil';
import { LIVE_PAGE } from '../../constants/app';
import { FLEET_ROOT_PAGES } from '../../constants/fleet';
import { useFleetSidenavItems } from '../../hooks/useFleetSidenavItems';
import { sidenavSectionsState } from '../../storage/app';
import SidenavWrapper from '../shared/SidenavWrapper';

export function FleetSidenav() {
  const [expanded, setExpanded] = useRecoilState(sidenavSectionsState);

  return (
    <SidenavWrapper
      pages={FLEET_ROOT_PAGES}
      useSidenavItems={useFleetSidenavItems}
      expanded={expanded}
      setExpanded={setExpanded}
      redirectPage={{
        ...LIVE_PAGE,
      }}
    />
  );
}
